import { prefix } from "../../design-tokens/meta";

export const componentName = "Checkbox";

export const componentClasses = Object.freeze({
    base: `${prefix}checkbox`,
    label: `${prefix}checkbox__label`,
    input: `${prefix}checkbox__input`,
    size: {
        lg: "",
        sm: `${prefix}checkbox--sm`,
    },
    fieldsetInline: `${prefix}fieldset--inline`,
    errorText: `${prefix}invalid-feedback`,
    fieldset: `${prefix}fieldset`,
    group: `${prefix}checkbox-group`,
});
